// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.teaminfo[data-v-f8e71c54] {
  display: inline-block;
  max-height: 55px;
  max-width: 55px;
}
.teaminfo img[data-v-f8e71c54] {
  max-width: 100%;
  border: 3px solid #4caf50;
  border-radius: 50%;
}
.teaminfo.b-red img[data-v-f8e71c54] {
  border-color: #f44336;
}
.teaminfo.b-orange img[data-v-f8e71c54] {
  border-color: #ff9800;
}
.teaminfo.offline img[data-v-f8e71c54] { /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
}
.three-item > .flex[data-v-f8e71c54]:first-child {
  text-align: left;
}
.three-item > .flex[data-v-f8e71c54]:last-child {
  text-align: right;
}
.three-item[data-v-f8e71c54],
.two-item[data-v-f8e71c54] {
  text-align: center;
}
.three-item > .flex[data-v-f8e71c54] {
  display: inline-block;
}
.three-item .teaminfo[data-v-f8e71c54],
.two-item .teaminfo[data-v-f8e71c54] {
  max-height: 53px;
  max-width: 53px;
}
.three-item .teaminfo img[data-v-f8e71c54],
.two-item .teaminfo img[data-v-f8e71c54] {
  width: 100%;
}
.team-title[data-v-f8e71c54] {
  margin-bottom: 15px;
  color: #808080;
  font-size: 16px;
  font-weight: 600;
}
.two-item > div:first-child .teaminfo[data-v-f8e71c54] {
  margin-left: 34%;
}
.two-item > div:last-child .teaminfo[data-v-f8e71c54] {
  margin-right: 25%;
}
.call-badge-content .call-badge[data-v-f8e71c54] {
  position: absolute;
  background-color: #4caf50;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  top: -7px;
  right: -6px;
  text-align: center;
  padding: 2px 0px;
}
.call-badge-content .call-badge i[data-v-f8e71c54] {
  color: #fff;
  font-size: 14px;
}
.teambadge[data-v-f8e71c54] {
  background-color: #4caf50;
  color: #fff;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 600;
  height: 30px;
  width: 30px;
  display: inline-block;
  padding: 5px 0;
  position: absolute;
  top: 11px;
  right: 12px;
}
.team-divider[data-v-f8e71c54] {
  max-width: 300px;
  margin: auto;
  height: 100%;
}
.team-divider[data-v-f8e71c54] .v-card {
  height: 100% !important;
}
.team-divider[data-v-f8e71c54] .v-card__title {
  min-height: 52px;
}
.team-divider[data-v-f8e71c54] .vb-content {
  max-height: 280px !important;
  height: 280px !important;
  overflow-y: auto !important;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
